import { Injectable, ErrorHandler } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
import { environment } from "src/environments/environment";

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
    if (!environment.development) {
      Sentry.init({
        dsn: "https://dbe6700f70d04acdb0bdeefa924e59b0@o390927.ingest.sentry.io/5911376",
        integrations: [
          new Integrations.BrowserTracing({
            tracingOrigins: ["localhost", "https://admintest.soliportal.com"],
            routingInstrumentation: Sentry.routingInstrumentation,
          }),
        ],

        tracesSampleRate: 1.0,
        maxValueLength: 1000,
        environment: environment.production
          ? "production"
          : environment.staging
          ? "testing"
          : "development",
        release: "solimarket-admin-portal@" + environment.version,
      });
    }
  }
  handleError(error) {
    if (!environment.development) {
      Sentry.captureException(error.originalError || error);
    }
    if (environment.development) {
      throw error;
    }
  }
}
